import { render, staticRenderFns } from "./activitiesAndTravels.vue?vue&type=template&id=2bb026ae&scoped=true"
import script from "./activitiesAndTravels.vue?vue&type=script&lang=js"
export * from "./activitiesAndTravels.vue?vue&type=script&lang=js"
import style0 from "./activitiesAndTravels.vue?vue&type=style&index=0&id=2bb026ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb026ae",
  null
  
)

export default component.exports